// @ts-nocheck
import React from 'react';
import logo from 'assets/img/login-logo.png';
import { Box, Typography, useTheme } from '@mui/material';
import { RejectedIcon } from 'pages/ProjectBudget/DayworkDocket/common/SvgIcons';
import PropTypes from 'prop-types';
import { useClientStyles } from '../../Styles';
import MarketingBanner from '../MarketingBanner';

const RejectModule = ({ rejectedMessage }) => {
  const theme = useTheme();
  const classes = useClientStyles();

  return (
    <>
      <Box sx={{ width: { xs: '130px', sm: '164px' } }}>
        <img className="logo" src={logo} alt="Logo" />
      </Box>

      <Box
        className={classes.actionCard}
        sx={{
          width: { xs: 'auto', sm: '765px' },
        }}
        px={{ xs: 3, sm: 5 }}
        py={{ xs: 3, sm: 5 }}
      >
        <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
          <RejectedIcon />
        </Box>
        <Typography
          variant="h4"
          align="center"
          sx={{ color: theme.palette.error.main }}
        >
          Rejected!
        </Typography>
        <Typography variant="body1" align="center" mt={{ xs: 2, sm: 3 }}>
          {rejectedMessage}
        </Typography>
        <Typography variant="body1" align="center" mt={{ xs: 2, sm: 3 }}>
          <strong>Note: </strong> This link will no longer be active since you
          have rejected the daywork.
        </Typography>
      </Box>
      <MarketingBanner />
    </>
  );
};

export default RejectModule;

RejectModule.propTypes = {
  rejectedMessage: PropTypes.string.isRequired,
};
